import React from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  getField,
  useForm,
} from "../../common/FormCreator/helpers";
import { submitDavinFoodsQuiz } from "../../redux/actions/index";

const ChemicalSafetyQuiz = ({ appData, submitQuiz }) => {
  const onboarding = appData.davinFoodsOnboarding;
  const fullName = `${appData.firstName} ${appData.lastName}`;
  const quizName = "chemicalSafetyQuiz";

  const initialData = {
    name: fullName,
    signature: fullName,
    date: moment().format("DD/MM/YYYY"),
  };
  const getVal = getField(initialData);

  const initialState = {
    blurb1: {
      htmlObj: (
        <p className="mb-2 text-center font-weight-bold">
          Please complete the Chemical Safety and Safe Cleaning at Davin Foods
          quiz as part of your induction with Reynolds.
        </p>
      ),
    },
    coshh: {
      title: "1. What does COSHH stand for?",
      value: getVal("coshh"),
      type: "radio",
      radioOptions: [
        "Control of Solutions Hands and Head",
        "Chemical of Safety Hazardous to Health",
        "Control of Substances Hazardous to Health",
        "Chemicals over Safety Health Hazards",
      ],
      mandatory: true,
    },
    mix: {
      title: "2. Why must you NOT mix chemicals?",
      value: getVal("mix"),
      type: "radio",
      radioOptions: [
        "You can mix chemicals",
        "It won't clean properly",
        "It doesn't smell nice",
        "You can create a deadly gas if you mix acidic and chlorinated chemicals",
      ],
      mandatory: true,
    },
    colour: {
      title: "3. What is the colour code for glass breakage?",
      value: getVal("colour"),
      type: "radio",
      radioOptions: ["Black", "White", "Yellow", "Blue"],
      mandatory: true,
    },
    clean: {
      title: "4. Why is it important to clean?",
      value: getVal("clean"),
      type: "radio",
      radioOptions: [
        "Ensure the food is safe",
        "Prevent cross contamination of allergens or strong flavours",
        "Ensure a clean environment for our workforce",
        "All of the above",
      ],
      mandatory: true,
    },
    procedures: {
      title:
        "5. What safety procedures do you have to bear in mind when cleaning?",
      value: getVal("procedures"),
      type: "radio",
      radioOptions: [
        "Wear provided PPE e.g. goggles, gloves etc.",
        "Ensure correct chemicals are used",
        "Method and frequency",
        "All of the above",
      ],
      mandatory: true,
    },
    name: {
      key: "name",
      title: "Name",
      value: getVal("name"),
      mandatory: true,
      disabled: true,
    },
    signature: {
      key: "signature",
      title: "Signature",
      value: getVal("signature"),
      mandatory: true,
      disabled: true,
    },
    date: {
      key: "date",
      title: "Date",
      value: getVal("date"),
      mandatory: true,
      disabled: true,
    },
  };
  const [fields, setField] = useForm(initialState);
  const completed =
    onboarding[quizName] &&
    (onboarding[quizName].status === "Pass" ||
      onboarding[quizName].retries === 0);
  const redirectBack = () =>
    history.push("/profile/edit/davin-foods-onboarding");
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);
    submitQuiz(quizName, {
      ...fieldValuesPayload,
    });
    redirectBack();
  };
  return (
    <>
      {completed ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={
            "Chemical Safety and Safe Cleaning Practices Induction at Davin Foods Quiz (PR905)"
          }
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"davinFoods"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};
ChemicalSafetyQuiz.propTypes = {
  appData: any,
  submitQuiz: func,
};
const mapDispatchToProps = {
  submitQuiz: submitDavinFoodsQuiz,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(ChemicalSafetyQuiz);
